/**
 * FLO SIGNATURE DESIGN SYSTEM v2 - Design Tokens
 * SINGLE SOURCE OF TRUTH - DO NOT HARDCODE VALUES OUTSIDE THIS FILE
 */

// APP_UI_PROFILE
export const APP_PROFILE = {
  app_name: 'Flo OS',
  mode: 'light_ops',
  accent: '#3B82F6',
  nav: 'left',
  max_width: 'full',
  typography: {
    headings: 'Montserrat',
    body: 'system',
    tables: 'system',
  },
  table_style: 'tight',
  forms: 'compact',
  kpi_emphasis: 'medium',
  allowed_shadows: false,
} as const;

// SPACING (strict 8pt grid)
export const SPACING = {
  0: '0',
  4: '4px',
  8: '8px',
  12: '12px',
  16: '16px',
  24: '24px',
  32: '32px',
  40: '40px',
  48: '48px',
  64: '64px',
} as const;

// RADIUS (single value per app) - COMPACT
export const RADIUS = '8px';

// COLORS - Light Ops Mode
export const COLORS = {
  // Background (warm off-white, never pure white)
  bg: {
    base: '#F9FAFB',
    panel: '#FFFFFF',
    hover: '#F3F4F6',
  },
  // Borders (subtle)
  border: {
    default: '#E5E7EB',
    hover: '#D1D5DB',
  },
  // Text
  text: {
    primary: '#111827',
    secondary: '#6B7280',
    tertiary: '#9CA3AF',
  },
  // Accent (single color - primary CTA, active nav, selection)
  accent: {
    default: '#3B82F6',
    hover: '#2563EB',
    active: '#1D4ED8',
  },
  // Status (muted)
  status: {
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#6366F1',
  },
} as const;

// TYPOGRAPHY - COMPACT MODE
export const TYPOGRAPHY = {
  headings: {
    fontFamily: 'Montserrat, sans-serif',
    sizes: {
      h1: '20px',
      h2: '16px',
      h3: '14px',
      h4: '12px',
    },
    weight: '600',
  },
  body: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    sizes: {
      default: '12px',
      small: '11px',
      tiny: '10px',
    },
  },
  // Convenient shortcuts for common component usage - COMPACT
  size: {
    '3xs': '7px',
    '2xs': '8px',
    xs: '9px',
    sm: '10px',
    md: '11px',
    base: '12px',
    lg: '13px',
    xl: '14px',
    '2xl': '16px',
    '3xl': '18px',
    '4xl': '20px',
    '5xl': '24px',
    '6xl': '28px',
    '7xl': '32px',
  },
  weight: {
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },
} as const;

// Z-INDEX
export const Z_INDEX = {
  base: 0,
  dropdown: 10,
  modal: 100,
  toast: 1000,
} as const;
